import { useValidateIsNotEmptyString } from "formvalidation/hooks";
import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  onChange: (newTitle: string) => void
  validatorKey: string
  maxLength: number
  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  labelContent?: string
  labelPosition?: "left" | "right"
}

const RequiredTextInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  const validation = useValidateIsNotEmptyString({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    ref: semanticRef.ref,
  })

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const onChange = (_, { value }) => {
    props.onChange(value);
  };

  const onBlur = async () => {
    props.onBlur?.();
  };

  return <Input
    ref={semanticRef.refSetter}
    value={props.value}
    placeholder={props.placeholder}
    onChange={onChange}
    maxLength={props.maxLength}
    error={validation.error.hasError}
    onBlur={onBlur}
    onFocus={() => props.onFocus?.()}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    fluid
    disabled={props.disabled}
    label={props.labelContent ? {
      basic: true,
      content: <span>{props.labelContent}</span>
    } : undefined}
    labelPosition={props.labelPosition}
  />;
};

export default RequiredTextInput;